import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * 限制輸入只能是中文、英文和空格的指令
 */
@Directive({
  selector: '[appChineseEnglishSpaceOnly]',
  standalone: true,
})
export class ChineseEnglishSpaceOnlyDirective {
  /**
   * 在(中文)組合輸入開始時設置 composing 為 true
   * 在(中文)組合輸入結束時，設置 composing 為 false 並過濾輸入
   * 在輸入事件中，如果不是組合輸入，則過濾輸入
   */
  private composing = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('compositionstart')
  onCompositionStart() {
    this.composing = true;
  }

  @HostListener('compositionend')
  onCompositionEnd() {
    this.composing = false;
    this.filterInput();
  }

  @HostListener('input')
  onInput() {
    if (!this.composing) {
      this.filterInput();
    }
  }

  private filterInput() {
    const input = this.el.nativeElement;
    const originalValue = input.value;
    // 只保留中文、英文和空格
    const filteredValue = originalValue.replace(
      /[^\u4e00-\u9fa5A-Za-z\s]/g,
      ''
    );
    if (filteredValue !== originalValue) {
      input.value = filteredValue;
      input.dispatchEvent(new Event('input'));
    }
  }
}
